<template>
  <div id="app">
      <router-view />
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss">
#steps{
    // /deep/ .van-step__circle{
    //     background-color:#969799 !important
    // }
    // /deep/ .van-step--finish .van-step__circle, .van-step--finish .van-step__line{
    //     background-color:#969799 !important
    // }
    /deep/ .van-step--vertical:not(:last-child)::after{
        border-bottom-width:0 !important
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue